<template>
    <confirmation-modal messageKey="applicationAccess.confirmEnable" :confirm="confirm" :focus-confirm="!application.authorized">
      <wo-region>
        <po-input-field v-if="application.authorized" v-model="authorization" v-focus="true" name="authorization" label-key="applicationAccess.authorization" />
        <template v-if="application.branded">
          <wo-label v-t="'applicationAccess.brand'" />
          <po-selector v-model="brand" :options="brands" />
        </template>
      </wo-region>
    </confirmation-modal>
</template>

<script>

import { BrandEnum } from '@/model/environment'
import { Company, ApplicationAccess } from '@/model/company'

import { applicationAccessRepository } from '@/repository/company'

import ConfirmationModal from '@/components/modal/ConfirmationModal'

export default {
  components: { ConfirmationModal },
  props: {
    company: Company,
    application: Object
  },
  data () {
    return {
      authorization: undefined,
      brand: undefined
    }
  },
  created () {
    this.brand = this.company && this.company.brand
  },
  computed: {
    brands: () => BrandEnum.values
  },
  methods: {
    confirm () {
      const entity = ApplicationAccess.forCompany(this.company, this.application, this.authorization, this.application.branded ? this.brand : undefined)
      return this.$store.dispatch(applicationAccessRepository.create, { entity: entity })
    }
  }
}
</script>
